export default "__VITE_ASSET__C_v_L83D__"